<template>
  <v-container class="fill-height login-shell" fluid>
    <v-row justify="center" align="center" class="fill-height">
      <v-col cols="12" sm="10" md="8" lg="7" xl="6">
        <v-card class="login-card">
          <v-btn class="back-home-btn" variant="text" size="small" color="primary"
                 prepend-icon="mdi-arrow-left" href="https://home.pcsetrackly.com/">
            Voltar
          </v-btn>
          <v-window v-model="step">

            <!-- ── Step 1: Login ───────────────────────────────────── -->
            <v-window-item :value="1">
              <v-row no-gutters>

                <v-col cols="12" md="6" class="login-form-panel pa-8 pa-md-10">
                  <div class="d-flex flex-column" style="min-height: 400px;">

                    <div class="text-center mb-7">
                      <v-img class="mx-auto mb-5" height="72" max-width="200" contain
                             src="@/assets/img/pcse1.png" />
                      <p class="text-h6 font-weight-bold login-title mb-1">Bem-vindo de volta</p>
                      <p class="text-body-2 text-medium-emphasis">Entre com suas credenciais para acessar</p>
                    </div>

                    <v-alert v-model="alert" class="mb-4" closable density="compact"
                             :text="alertText" :type="alertType" />

                    <v-form ref="formLogin" @submit.prevent="onSubmitLogin" class="flex-grow-1">
                      <v-text-field
                        v-model="username"
                        variant="outlined"
                        color="primary"
                        label="E-mail"
                        prepend-inner-icon="mdi-email-outline"
                        :rules="requiredEmail"
                        class="mb-2"
                      />
                      <v-text-field
                        v-model="pwd"
                        variant="outlined"
                        color="primary"
                        label="Senha"
                        prepend-inner-icon="mdi-lock-outline"
                        type="password"
                        :rules="requiredField"
                        class="mb-1"
                      />
                      <div class="d-flex justify-end mb-5">
                        <v-btn variant="text" color="secondary" size="small" @click="step=3">
                          Esqueci a senha
                        </v-btn>
                      </div>
                      <v-btn block color="primary" size="large" variant="flat" type="submit"
                             :loading="loadingSignIn" class="login-btn mb-5">
                        Entrar
                      </v-btn>
                    </v-form>

                    <div class="text-center">
                      <span class="text-body-2 text-medium-emphasis">
                        É aluno e ainda não tem conta?
                      </span>
                      <v-btn variant="text" color="primary" size="small" @click="step=2">
                        Criar conta
                      </v-btn>
                    </div>

                  </div>
                </v-col>

                <v-col cols="12" md="6" class="login-aside login-aside-strong pa-10
                                               d-none d-md-flex flex-column
                                               align-center justify-center">
                  <div class="login-aside-deco" />
                  <v-icon size="64" color="white" icon="mdi-chart-timeline-variant-shimmer" class="mb-6" />
                  <p class="text-h5 font-weight-bold text-white text-center mb-2">
                    TRACKLY
                  </p>
                  <p class="text-body-2 text-white text-center login-aside-text">
                    Sistema Integrado de Gestão de Desempenho Acadêmico.
                  </p>
                  <div class="login-aside-chips mt-6 d-flex flex-column ga-2">
                    <div class="login-chip">
                      <v-icon size="16" icon="mdi-account-group" class="mr-2" />
                      TBL — Avaliações individuais e em equipe
                    </div>
                    <div class="login-chip">
                      <v-icon size="16" icon="mdi-text-box-edit" class="mr-2" />
                      Avaliações discursivas
                    </div>
                    <div class="login-chip">
                      <v-icon size="16" icon="mdi-clipboard-check" class="mr-2" />
                      OSCE
                    </div>
                    <div class="login-chip">
                      <v-icon size="16" icon="mdi-chart-box" class="mr-2" />
                      Estatísticas Acadêmicas: turma / individual
                    </div>
                  </div>
                </v-col>

              </v-row>
            </v-window-item>

            <!-- ── Step 2: Cadastro ───────────────────────────────── -->
            <v-window-item :value="2">
              <v-row no-gutters>

                <v-col cols="12" md="4" class="login-aside login-aside-strong pa-10
                                               d-none d-md-flex flex-column
                                               align-center justify-center">
                  <div class="login-aside-deco" />
                  <v-img class="mb-6" height="64" max-width="180" contain
                         src="@/assets/img/pcse1.png" />
                  <p class="text-body-2 text-white text-center login-aside-text mb-6">
                    Já possui uma conta? Faça login para continuar.
                  </p>
                  <v-btn variant="outlined" color="white" @click="step--">
                    Entrar
                  </v-btn>
                </v-col>

                <v-col cols="12" md="8" class="login-form-panel pa-8 pa-md-10">
                  <p class="text-h6 font-weight-bold login-title mb-1">Criar Conta de Aluno</p>
                  <p class="text-body-2 text-medium-emphasis mb-5">
                    Preencha seus dados. Você vai receber um e-mail para definir sua senha de primeiro acesso.
                  </p>

                  <v-alert v-model="alert" class="mb-4" closable density="compact"
                           :text="alertText" :type="alertType" />

                  <v-form v-model="isFormValid" @submit.prevent="onSubmit">
                    <v-row dense>
                      <v-col cols="12">
                        <v-text-field
                          v-model="nome.value.value"
                          variant="outlined" color="primary"
                          label="Nome completo"
                          :counter="100"
                          :error-messages="nome.errorMessage.value"
                        />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-select
                          v-model="sexo.value.value"
                          variant="outlined" color="primary"
                          label="Gênero"
                          item-title="nome" item-value="tipo"
                          :error-messages="sexo.errorMessage.value"
                          :items="items2"
                        />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="ra.value.value"
                          variant="outlined" color="primary"
                          label="RA"
                          :error-messages="ra.errorMessage.value"
                        />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-select
                          v-model="turma_id.value.value"
                          variant="outlined" color="primary"
                          label="Turma"
                          item-title="codigo" item-value="id"
                          :error-messages="turma_id.errorMessage.value"
                          :items="turmasCadastro"
                        />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="fone.value.value"
                          v-mask="['(##) ####-####', '(##) #####-####']"
                          variant="outlined" color="primary"
                          label="Telefone"
                          :error-messages="fone.errorMessage.value"
                        />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="cpf.value.value"
                          variant="outlined" color="primary"
                          label="CPF (somente números)"
                          :counter="11"
                          :error-messages="cpf.errorMessage.value"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="email.value.value"
                          variant="outlined" color="primary"
                          label="E-mail"
                          :error-messages="email.errorMessage.value"
                        />
                      </v-col>
                    </v-row>

                    <div class="d-flex align-center ga-3 mt-3">
                      <v-btn color="primary" variant="flat" type="submit"
                             :disabled="!isFormValid" :loading="loadingSignUp">
                        Cadastrar
                      </v-btn>
                      <v-btn color="primary" variant="outlined" @click="handleReset">
                        Limpar
                      </v-btn>
                    </div>
                  </v-form>
                </v-col>

              </v-row>
            </v-window-item>

            <!-- ── Step 3: Esqueci a senha ────────────────────────── -->
            <v-window-item :value="3">
              <v-row no-gutters>

                <v-col cols="12" md="6" class="login-form-panel pa-8 pa-md-10">
                  <div class="d-flex flex-column" style="min-height: 360px;">

                    <div class="text-center mb-7">
                      <v-img class="mx-auto mb-5" height="72" max-width="200" contain
                             src="@/assets/img/pcse1.png" />
                      <p class="text-h6 font-weight-bold login-title mb-1">Recuperar Senha</p>
                      <p class="text-body-2 text-medium-emphasis">
                        Enviaremos um link de redefinição para seu e-mail
                      </p>
                    </div>

                    <v-alert v-model="alert" class="mb-4" closable density="compact"
                             :text="alertText" :type="alertType" />

                    <v-form ref="formResetPwd" @submit.prevent="onSubmitResetPwd" class="flex-grow-1">
                      <v-text-field
                        v-model="emailReset"
                        variant="outlined" color="primary"
                        label="E-mail cadastrado"
                        prepend-inner-icon="mdi-email-outline"
                        :rules="requiredEmail"
                        class="mb-4"
                      />
                      <v-btn block color="primary" size="large" variant="flat" type="submit"
                             :loading="loadingResetPwd" prepend-icon="mdi-send-variant" class="mb-4">
                        Enviar link de recuperação
                      </v-btn>
                      <div class="text-center">
                        <v-btn variant="text" color="secondary" size="small" @click="step=1">
                          Voltar ao login
                        </v-btn>
                      </div>
                    </v-form>

                  </div>
                </v-col>

                <v-col cols="12" md="6" class="login-aside login-aside-strong pa-10
                                               d-none d-md-flex flex-column
                                               align-center justify-center">
                  <div class="login-aside-deco" />
                  <v-icon size="64" color="white" icon="mdi-lock-reset" class="mb-6" />
                  <p class="text-h6 font-weight-bold text-white text-center mb-3">
                    Redefinir Senha
                  </p>
                  <p class="text-body-2 text-white text-center login-aside-text">
                    Informe o e-mail cadastrado e enviaremos as instruções para redefinir sua senha.
                  </p>
                </v-col>

              </v-row>
            </v-window-item>

            <!-- ── Step 4: Alterar senha ──────────────────────────── -->
            <v-window-item :value="4">
              <v-row no-gutters>

                <v-col cols="12" md="6" class="login-form-panel pa-8 pa-md-10">
                  <div class="d-flex flex-column" style="min-height: 360px;">

                    <div class="text-center mb-7">
                      <v-img class="mx-auto mb-5" height="72" max-width="200" contain
                             src="@/assets/img/pcse1.png" />
                      <p class="text-h6 font-weight-bold login-title mb-1">Nova Senha</p>
                      <p class="text-body-2 text-medium-emphasis">
                        Escolha uma senha forte para sua conta
                      </p>
                    </div>

                    <v-alert v-model="alert" class="mb-4" closable density="compact"
                             :text="alertText" :type="alertType" />

                    <v-form ref="formChangePwd" @submit.prevent="onSubmitChangePwd" class="flex-grow-1">
                      <v-text-field
                        v-model="pwd"
                        variant="outlined" color="primary"
                        label="Nova senha"
                        prepend-inner-icon="mdi-lock-outline"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="passwordRules"
                        :type="show1 ? 'text' : 'password'"
                        @click:append="show1 = !show1"
                        class="mb-2"
                      />
                      <v-text-field
                        v-model="checkPwd"
                        variant="outlined" color="primary"
                        label="Confirmar nova senha"
                        prepend-inner-icon="mdi-lock-check-outline"
                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="requiredField.concat(passwordConfirmationRule)"
                        :type="show2 ? 'text' : 'password'"
                        @click:append="show2 = !show2"
                        class="mb-4"
                      />
                      <v-btn block color="primary" size="large" variant="flat" type="submit"
                             :loading="loadingChangePwd" prepend-icon="mdi-lock-reset" class="mb-4">
                        Alterar Senha
                      </v-btn>
                      <div class="text-center">
                        <v-btn variant="text" color="secondary" size="small" @click="step=1">
                          Voltar ao login
                        </v-btn>
                      </div>
                    </v-form>

                  </div>
                </v-col>

                <v-col cols="12" md="6" class="login-aside login-aside-strong pa-10
                                               d-none d-md-flex flex-column
                                               align-center justify-center">
                  <div class="login-aside-deco" />
                  <v-icon size="64" color="white" icon="mdi-shield-check-outline" class="mb-6" />
                  <p class="text-h6 font-weight-bold text-white text-center mb-3">
                    Recuperação de Senha
                  </p>
                  <p class="text-body-2 text-white text-center login-aside-text">
                    Use letras maiúsculas, números e caracteres especiais para uma senha mais segura.
                  </p>
                </v-col>

              </v-row>
            </v-window-item>

          </v-window>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script src="@/assets/js/login.js" />

<style scoped>
/* ── Shell ────────────────────────────────────────────────────── */
.login-shell {
  min-height: 100vh;
}

/* ── Card ─────────────────────────────────────────────────────── */
.login-card {
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  border: 1px solid var(--pcse-border);
  background: var(--pcse-surface);
  box-shadow: 0 32px 80px rgba(13, 31, 46, 0.13);
}

.back-home-btn {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
}

/* ── Form panel ───────────────────────────────────────────────── */
.login-form-panel {
  background: linear-gradient(170deg, #ffffff 0%, #f8fbfd 100%);
}

/* ── Aside ────────────────────────────────────────────────────── */
.login-aside {
  position: relative;
  overflow: hidden;
}

.login-aside-strong {
  background: var(--pcse-strong-panel);
}

/* decorative blurred circles */
.login-aside-deco {
  position: absolute;
  inset: 0;
  pointer-events: none;
}
.login-aside-deco::before,
.login-aside-deco::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.055);
}
.login-aside-deco::before {
  width: 260px;
  height: 260px;
  top: -80px;
  right: -80px;
}
.login-aside-deco::after {
  width: 180px;
  height: 180px;
  bottom: -60px;
  left: -60px;
}

.login-aside-text {
  opacity: 0.82;
  line-height: 1.65;
  max-width: 240px;
}

/* Feature chips on login aside */
.login-aside-chips {
  width: 100%;
  max-width: 260px;
}
.login-chip {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.10);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.90);
}

/* ── Typography ───────────────────────────────────────────────── */
.login-title {
  color: #16324a;
  letter-spacing: 0.01em;
}

/* ── Buttons ──────────────────────────────────────────────────── */
.login-btn {
  letter-spacing: 0.04em;
  font-weight: 600;
}

/* ── Responsive ───────────────────────────────────────────────── */
@media (max-width: 959px) {
  .login-card {
    border-radius: 16px;
  }
}
</style>
